import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function SEO({ title, description, keywords, image }) {
  const location = useLocation();

  useEffect(() => {
    document.title = title || 'OptimizeRust - Оптимизация сервера Rust';
    
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    const canonical = document.querySelector('link[rel="canonical"]') || document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', `https://optimizerust.ru${location.pathname}`);
    if (!document.querySelector('link[rel="canonical"]')) {
      document.head.appendChild(canonical);
    }

    if (description) {
      updateMetaTag('description', description);
      updateMetaTag('og:description', description, true);
      updateMetaTag('twitter:description', description);
    }

    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    if (image) {
      updateMetaTag('og:image', image, true);
      updateMetaTag('twitter:image', image);
    }

    updateMetaTag('og:url', `https://optimizerust.ru${location.pathname}`, true);
  }, [location, title, description, keywords, image]);

  return null;
}

export default SEO;

